import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

const FormSelectionDialog = ({
  open,
  onClose,
  dialogTitle = "",
  dialogContent = null,
  dialogActions = null,
}) => {
  const handleClose = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    onClose();
  };

  return (
    <Dialog
      PaperProps={{
        style: {
          borderRadius: "1rem",
        },
      }}
      open={open}
      onClose={handleClose}
    >
      {dialogTitle && <DialogTitle>{dialogTitle}</DialogTitle>}
      {dialogContent && <DialogContent>{dialogContent}</DialogContent>}
      {dialogActions && <DialogActions>{dialogActions}</DialogActions>}
    </Dialog>
  );
};

export default FormSelectionDialog;
